import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Palette } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function GraphismeLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/graphisme/auth/login", { email, password });
      // Portail unique : le client atterrit toujours sur la rubrique Accueil
      navigate("/graphisme/espace");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Identifiants incorrects");
    } finally { setBusy(false); }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/graphisme/auth/forgot", { email: email.trim() });
    } catch { /* réponse volontairement identique — ne rien révéler */ }
    setSent(true);
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-4">
      <form onSubmit={forgot ? submitForgot : submit} className="bg-white border border-neutral-200 rounded-2xl shadow-sm p-8 w-full max-w-sm space-y-5" data-testid="gclient-login">
        <div className="text-center">
          <div className="w-12 h-12 rounded-xl bg-neutral-900 text-white flex items-center justify-center mx-auto mb-3">
            <Palette className="w-6 h-6" />
          </div>
          <h1 className="font-heading font-bold text-xl">Espace création graphique</h1>
          <p className="text-sm text-neutral-500 mt-1">Digital & Graphic Agency — accès sécurisé client</p>
        </div>
        {!forgot ? (
          <>
            <div>
              <Label className="text-xs">Identifiant (email)</Label>
              <Input type="email" className="mt-1" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="gclient-email" />
            </div>
            <div>
              <Label className="text-xs">Mot de passe</Label>
              <Input type="password" className="mt-1" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="gclient-password" />
            </div>
            <div className="text-right -mt-2">
              <button type="button" onClick={() => { setForgot(true); setError(""); setSent(false); }}
                className="text-xs text-neutral-500 hover:text-neutral-900 transition-colors" data-testid="gclient-forgot">
                Mot de passe oublié ?
              </button>
            </div>
            {error && <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="gclient-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white" data-testid="gclient-login-btn">
              {busy ? "Connexion…" : "Se connecter"}
            </Button>
            <p className="text-[11px] text-neutral-400 text-center">Vos identifiants vous ont été transmis par votre graphiste.</p>
          </>
        ) : sent ? (
          <>
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg p-3" data-testid="gclient-forgot-success">
              Si un compte est associé à cette adresse, un email avec un lien sécurisé vient d'être envoyé.
            </div>
            <button type="button" onClick={() => { setForgot(false); setSent(false); }}
              className="w-full text-xs text-neutral-400 hover:text-neutral-900 transition-colors" data-testid="gclient-forgot-back">
              ← Retour à la connexion
            </button>
          </>
        ) : (
          <>
            <p className="text-sm text-neutral-500">Indiquez votre email — vous recevrez un lien sécurisé pour choisir un nouveau mot de passe.</p>
            <div>
              <Label className="text-xs">Identifiant (email)</Label>
              <Input type="email" className="mt-1" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="gclient-forgot-email" />
            </div>
            <Button type="submit" disabled={busy || !email.trim()} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white" data-testid="gclient-forgot-submit">
              {busy ? "Envoi…" : "Recevoir le lien"}
            </Button>
            <button type="button" onClick={() => { setForgot(false); setSent(false); }}
              className="w-full text-xs text-neutral-400 hover:text-neutral-900 transition-colors" data-testid="gclient-forgot-back">
              ← Retour à la connexion
            </button>
          </>
        )}
      </form>
    </div>
  );
}
